import { TResult, makeSuccess, ISgApiService, IEndpoint } from "../../../sg-core";
import { ILocationItem } from "../store/reducers/formContextReducer";

export interface ILocationListResultDTO {
    lista: { id: number; teksti: string }[];
}
export interface ILocationListResult {
    locations: ILocationItem[];
}

export interface IFormContextService {
    getLocationList(): Promise<TResult<ILocationListResult>>;
}

export const getFormContextService = (apiService: ISgApiService, Enpoint: IEndpoint): IFormContextService => {
    const getLocationList = async (): Promise<TResult<ILocationListResult>> => {
        const action = "etsi_lintsikohde";
        const apiResponse = await apiService.sendAction<ILocationListResultDTO>(Enpoint, action, {});

        if (apiResponse.isSuccess === true) {
            return makeSuccess<ILocationListResult>({
                locations: apiResponse.value.lista.map((s) => ({ id: s.id, title: s.teksti })),
            });
        }
        return apiResponse;
    };

    return {
        getLocationList,
    };
};
